// import jQuery from 'CommonScripts/jquery-1.10.2';
require('../../common/shadowbox/shadowbox');

const overlayDialog = (function ($) {
    function showDialog(html) {

        var tmp = document.createElement("div");
        tmp.setAttribute("class", "tmpModal");

        document.body.appendChild(tmp);

        var tempDialogDiv = document.createElement("div");
        tempDialogDiv.innerHTML = html.replace(/data-original/g, "src");

        tmp.appendChild(tempDialogDiv);

        html = html.replace(/data-original/g, "src");

        $('#blankcontent').imagesLoaded().always(function () {
            /* TODO for later */
            if ($('#blankcontent .article-content > iframe').is(':only-child')) {
            } else {
            }

            var width = $("#blankcontent > div").width() + 20,
                height = $("#blankcontent > div").height() + 20;

            if (height > $(window).height() * 0.8) {
                height = $(window).height() * 0.8;
            }

            Shadowbox.open({
                player: 'html',
                content: html,
                width: width,
                height: height,
                options: {
                    onOpen: function () {
                        $('.tmpModal').remove();
                    },
                    enableKeys: false
                }
            });
        });
    }

    return { show: showDialog }
})(jQuery);

export default overlayDialog;